var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDrawerFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 0.5H1.83333C0.916664 0.5 0.174998 1.25 0.174998 2.16667L0.166664 15.5L6 13L11.8333 15.5V2.16667C11.8333 1.25 11.0833 0.5 10.1667 0.5ZM10.1667 13L6 11.1833L1.83333 13V2.16667H10.1667V13Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 0.5H1.83333C0.916664 0.5 0.174998 1.25 0.174998 2.16667L0.166664 15.5L6 13L11.8333 15.5V2.16667C11.8333 1.25 11.0833 0.5 10.1667 0.5ZM10.1667 13L6 11.1833L1.83333 13V2.16667H10.1667V13Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrawerFollow);
export default __webpack_public_path__ + "static/media/iconDrawerFollow.536578429e610c5e25108be9a0c77237.svg";
export { ForwardRef as ReactComponent };